import Cookies from 'universal-cookie';
import { CONTENT_API_URL } from '../util/config';
import fetcher from '../util/fetcher';
import log from '../util/log';
import {
  COOKIE_TICKET,
  COOKIE_PERSONALIZATION_ID,
  HEADER_CHEWY_INTERNAL,
  COOKIE_CONTENT_PREVIEW,
} from '../util/requestUtils';
import {
  ApiContentPage,
  ApiStandardBanner,
  ApiStandardNonSku,
  ApiZone,
  ContentApi,
} from './generated-client/Content-Service-A.v1';
import { Configuration } from './generated-client/Content-Service-A.v1/runtime';

export const placeHolderApiZone: ApiZone = {
  components: [],
  order: 1,
};

const allowedComponents = ['STANDARD-SKU', 'STANDARD-BANNER'];

const checkType = (allowedComponents?: string[], type?: string) => {
  // If no array is defined, default to allowing all components
  if (!allowedComponents) {
    return true;
  }

  if (type && allowedComponents.includes(type)) {
    return true;
  }
  // eslint-disable-next-line no-console
  console.warn('Disallowed CMS component.', type);
  return false;
};

// Currently only allowing the "Standard SKU" and "Standard Banner" component so we need to filter out other widgets just in case
export const selectAllowedComponents = (zone: ApiZone): ApiZone => {
  const zoneWithRightComponents = {
    components: zone.components.filter((component) =>
      checkType(allowedComponents, component?.type),
    ),
    order: 1,
  };

  return zoneWithRightComponents;
};

// Used only for Food Finder
// filter out everything but non-sku
export const selectStandardNonSkuComponents = (zone: ApiZone): ApiZone => {
  const zoneWithStandardNonSkuComponents = {
    components: zone.components
      .filter((component): component is ApiStandardNonSku => component.type === 'STANDARD-NON-SKU')
      .filter((component) => component.items && component.items.length > 0),
    order: 1,
  };

  return zoneWithStandardNonSkuComponents;
};

export const selectStandardBannerComponents = (zone: ApiZone): ApiZone => {
  const zoneWithStandardNonSkuComponents = {
    components: zone.components.filter(
      (component): component is ApiStandardBanner => component.type === 'STANDARD-BANNER',
    ),
    order: 1,
  };

  return zoneWithStandardNonSkuComponents;
};

export const getZone = (zoneIndex: number | null, cmsData: ApiContentPage): ApiZone | null => {
  if (!cmsData.zones) return null;
  if (cmsData.zones.length === 1) {
    return cmsData.zones[0];
  }
  if (zoneIndex === null) return null;
  return cmsData.zones[zoneIndex];
};

const loadCms = ({
  queryKey: [, zoneQueryValue, pageGeneralType, pageSelectionKey],
}: {
  queryKey: [any, number, string, string];
}): Promise<ApiContentPage> => {
  const cfg = new Configuration({
    fetchApi: fetcher,
    basePath: CONTENT_API_URL,
    middleware: [],
  });
  if (zoneQueryValue !== null) {
    zoneQueryValue = zoneQueryValue + 1;
  }
  return new Promise((resolve, reject) => {
    const cookies = new Cookies();
    new ContentApi(cfg)
      .getGeneralPage({
        generalType: pageGeneralType,
        selectionKey: pageSelectionKey,
        xPersonalizationID: cookies.get(COOKIE_PERSONALIZATION_ID),
        xChewyAuthIdToken: cookies.get(COOKIE_TICKET),
        xChewyInternal: cookies.get(HEADER_CHEWY_INTERNAL),
        chewyOverridesContentPreview: cookies.get(COOKIE_CONTENT_PREVIEW),
      })
      .then((data: ApiContentPage) => {
        resolve(data);
      })
      .catch((error) => {
        log.error('An error occurred while retrieving content.', error);
        reject(error);
      });
  });
};

loadCms.key = 'LOAD_PET_PROFILE_CMS';

export default loadCms;
